import { FC, ReactNode } from 'react';

import { ChevronDownIcon } from '../../../assets/icons/index';
import Button from '../../../components/button/index';
import { DividendSortBy, DividendSortOrder } from '../../../hooks/dividend/dividend.types';

type Props = {
  onSortClick: (field: DividendSortBy) => void;
  sortByCell: DividendSortBy;
  sortField: DividendSortBy | null;
  sortOrder: DividendSortOrder | null;
  title: ReactNode | string;
};

export const DividendSortingCell: FC<Props> = ({
  onSortClick,
  sortByCell,
  sortField,
  sortOrder,
  title,
}) => (
  <div className="flex cursor-pointer items-center gap-1" onClick={() => onSortClick(sortByCell)}>
    <span className="text-label-md font-[450] text-[#172335]">{title}</span>
    <Button
      className="relative flex size-4 justify-center rounded hover:bg-gray-200"
      styleType="NONE"
    >
      {sortField === sortByCell && sortOrder != null ? (
        <ChevronDownIcon
          className={sortOrder === DividendSortOrder.ASC ? 'w-2' : 'w-2 rotate-180'}
        />
      ) : (
        <>
          <ChevronDownIcon className="absolute -top-[3px] w-2 rotate-180" />
          <ChevronDownIcon className="absolute -bottom-[3px] w-2" />
        </>
      )}
    </Button>
  </div>
);
